module.exports = "/fonts/fa-brands-400.ttf?b7d071b9c3c197bff4af902070622423";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-brands-400.ttf
// module id = kc0D
// module chunks = 0 1